<template>
  <div class="container spectators">
    <v-row>
      <v-col md="12" cols="12" v-if="!loadingPage">
        <WarningAlert v-if="age18">
            {{ $t("spectators.alert_text_1") }}<br />
            {{ $t("spectators.alert_text_2") }}<br />
            {{ $t("spectators.alert_text_3") }}
        </WarningAlert> 
        <WarningAlert v-else>
          <p class="mb-0">{{ $t("riders.content_4") }}</p>  
          <p class="mb-0">{{ $t("spectators.alert_text_4") }}</p>    
        </WarningAlert>              
      </v-col>
      <v-col v-if="age18" md="12" cols="12" class="text-right pt-0 pb-0" >
        <v-btn :color="`${buttonColor}`" dark class="mb-2" @click="addSpectator">
          {{ $t("spectators.addSpectator")}}
        </v-btn>
      </v-col>
      <v-col v-if="age18" md="12" cols="12" class="pt-0">
        <v-data-table
          :headers="spectatorsHeaders"
          :items="spectatorsItems"
          class="elevation-1"
          dense
          :loading="loadingData"
          :loading-text="$t('yourRegistration.loading_text')"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
          <template v-slot:top>          
            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-form ref="form" @submit.prevent="editSpectator">
                  <v-card-title>
                    <span class="headline">{{ $t("spectators.edit_spectator") }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-row no-gutters class="mt-2">
                      <v-col md="6" cols="12" class="pb-0">
                        <v-text-field
                          v-model="form.fName"
                          :label="$t('riders.first_name')"
                          disabled
                          outlined dense
                          class="mr-0 mr-md-1"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6" cols="12" class="pb-0 pt-0">
                        <v-text-field
                          v-model="form.lName"
                          :label="$t('riders.last_name')"
                          disabled outlined dense
                        ></v-text-field>
                      </v-col>
                      <v-col md="12" cols="12" class="pb-0 pt-0">
                        <v-select 
                          outlined dense
                          v-model="form.relationship"
                          :label="$t('riders.relationship')"
                          :items="itemsRelationshipOptions"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      @click="close"
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                      >{{ $t("riders.cancel") }}</v-btn>
                    <v-btn
                      type="submit"
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                    >{{ $t("riders.save") }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ $t('spectators.delete_spectator') }}</v-card-title>
                <v-card-text>
                  <p class="mt16">{{ $t('spectators.sure_delete') }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete">{{ $t('riders.cancel') }}</v-btn>
                  <v-btn
                        :color="`${buttonColor}`"
                        class="btn mb-2"
                        @click="deleteItemConfirm"
                      >{{ $t('riders.delete') }}</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:[`item.relationship`]="{ item }">
            {{ item.relationship ? $t(`relationship.${item.relationship.toLowerCase()}`) : '' }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon v-if="item.isEdit" small class="mr-2" @click="editItem(item)">fa far fa-pencil-alt</v-icon>
            <v-icon v-if="item.isEdit" small @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
          </template>
          <template v-slot:[`item.relationship`]="{ item }">
            {{ $te("relationship."+(item.relationship || '').toLowerCase()) ? $t("relationship."+(item.relationship || '').toLowerCase()) : item.relationship }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>   

<script>
import Snack from "@/components/notifications/Snack";
import WarningAlert from "@/components/alert/WarningAlert";
import { VRow, VCol, VBtn, VDataTable, VDialog, VIcon,
         VCard, VCardTitle, VCardText, VForm, VTextField,
         VCardActions, VSpacer, VSelect } from 'vuetify/lib';
import RelationshipService from "@/services/RelationshipService";
import AuthService from "@/services/AuthService";
import { mapState } from 'vuex';

export default {
  name: "Spectators",
  components: {
    Snack, WarningAlert, 
    VRow, VCol , VBtn, VDataTable, VDialog, VIcon,
    VCard, VCardTitle, VCardText, VForm, VTextField,
    VCardActions, VSpacer, VSelect
  },
  data() {
    const spectatorsForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationShip: ""
    });
    return {
      msg_snackbar: '',
      color_snackbar: '',
      snackbar: false,
      spectatorsItems: [],
      buttonColor: "#000",
      dialog: false,
      form: Object.assign({}, spectatorsForm),
      dialogDelete: false,
      editedIndex: -1,
      defaultItem: {
        firstName: "",
        lastName: "",
        relationShip: ""
      },
      itemsRelationship: [],
      loadingData: true
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR'); 
    this.$store.dispatch('setUserAction',{ forceUpdate: false, forceParticipants: false, disabledLoading: true });
  },
  updated() {},
  mounted() {
    this.$emit("titlePage", "riders.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);  
    this.getSpectator();
    this.getItemsRelationship();
  },
  computed: {
    ...mapState({
      loadingPage: (state) => {
        if(state && state.session) return state.session.loadingPage;
        return true;
      },
      age18: (state) => state.session.age18
    }),
    spectatorsHeaders(){
      return [
        {
          text: this.$t("authorization.livelaps_id"),
          align: "",
          sortable: true,
          value: "userId"
        },
        {
          text: this.$t("riders.first_name"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.email"), value: "email" },
        { text: this.$t("riders.relationship"), value: "relationship" },
        {
          text: this.$t("riders.actions"),
          value: "actions",
          sortable: false
        }
      ]
    },
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        return {
          text: this.$t(`relationship.${el.toLowerCase()}`),
          value: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    }
  },
  methods: {
      async getSpectator() {
        let spectators = [];
        await AuthService.getUserCurrent().then(response =>{
          if(response.data.success == 1){
            this.spectatorsItems.push({
              userId: response.data.message.id,
              linkedMemberId: response.data.message.id,
              fName: response.data.message.firstName,
              lName: response.data.message.lastName,
              relationship: "you",
              isEdit: false,
              birthday: response.data.message.birthday,
              email: response.data.message.email
            });
          }
        });
        await RelationshipService.getUserRoles().then(response =>{
            let userRolesItems = [];
            if(response.data.success == 1){
            userRolesItems = response.data.message;
            userRolesItems.find(x => {
                if(x.userRoleCode === 'Spectator'){
                this.userRoleId = x.id;
                }
            });
            }
        });
        await RelationshipService.showLinkedMembers(this.userRoleId).then(response => {
          if(response.data.success == 1){
            spectators = response.data.message.map(element => {
              return {
                ...element,
                isEdit: true
              };
            });
          }
        });
        this.spectatorsItems = this.spectatorsItems.concat(spectators);
        this.loadingData = false;
      },
      addSpectator() {
        this.$router.push({
            path: "SpectatorsCreate"
        }); 
      },
      editItem(item) {
      this.editedIndex = this.spectatorsItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialog = true;
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.form = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.form = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      deleteItem(item) {
        this.editedIndex = this.spectatorsItems.indexOf(item);
        this.form = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm() {
        this.spectatorsItems.splice(this.editedIndex, 1);
        this.closeDelete();
        
        RelationshipService.relationshipDelete(this.form.linkedMemberId).then(response => {

          if(response.data.success == 1){
            this.spectatorsItems = [];
            this.showSnackBar(this.$t("riders.msg_success_deleted"), "success");
            this.getSpectator();
          }

        });
      },
      editSpectator() {
        let data = {};
        data.relId = this.form.linkedMemberId;
        data.relType = this.form.relationship;
        data.userRoleId = this.userRoleId;
        RelationshipService.relationshipUpdate(data).then(response => {
          if(response.data.success == 1){
            this.dialog = false;
            this.spectatorsItems = [];
            this.showSnackBar(this.$t("riders.msg_success_edited"), "success");
            this.getSpectator();
          }
        });
      },
      showSnackBar(msg, color){
        this.snackbar = true;
        this.msg_snackbar = msg;
        this.color_snackbar = color;
        setTimeout(() => this.snackbar = false, 3000);
      },
      getItemsRelationship(){
        RelationshipService.showRelationshipValues().then(response => {
          
          if(response.data.success == 1){
            this.itemsRelationship = response.data.message;
          }
        });
    }
  }
};
</script>

<style>
.spectators .v-data-table-header,
.spectators .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
</style>